import {
    I18nMessages,
} from '../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages';
import { frMessages } from '../../../../xlink/locales/fr/allMessages';
import {
    frRenamingSectorsAsGroup,
} from '../../../../xlink/locales/frRenamings/frRenamingSectorsAsGroups';
import {
    frRenamingAuditsAsCheckList,
} from '../../../../xlink/modules/Audits/Locales/fr/frRenamingAuditsAsCheckList';
import {
    frCataloguesAsCatalogues,
} from '../../../../xlink/modules/Collections/Locales/fr/frCataloguesAsCatalogues';
import {
    frRenamingCentersAsSalePoint,
} from '../../../../xlink/modules/Shops/Locales/fr/frRenamingCentersAsSalePoint';
import { frOxylinkRenaming } from './frOxylinkRenaming';

export const frOxylinkMessages: I18nMessages = {
    ...frMessages,
    ...frRenamingSectorsAsGroup,
    ...frRenamingCentersAsSalePoint,
    ...frCataloguesAsCatalogues,
    ...frRenamingAuditsAsCheckList,
    ...frOxylinkRenaming,
};
